<template>
  <FormSubmitPopup
    :title="$t('adjustInventory')"
    v-model="value"
    :rightMethod="onSubmitted"
    @popupClose="$emit('input', false)"
    :rightButtonText="$t('confirm')"
    hasAlert
    medium>
    <template v-slot:input>
      <v-layout align-end justify-start>
        <v-flex md3>
          <v-autocomplete
            :items="warehousesSites"
            item-text="siteName"
            return-object
            v-model="warehouseSite"
            :label="$t('warehouseSite')"
            :rules="[fieldIsRequired('Warehouse site')]"
            class="required_field"></v-autocomplete>
        </v-flex>
        <v-flex md1></v-flex>
        <v-flex md3>
          <v-text-field
            :label="$t('permissionCode')"
            class="required_field"
            :rules="[v => v === '20200125' || $t('wrongPermissionCode')]"></v-text-field>
        </v-flex>
      </v-layout>
      <v-layout>
        <v-flex md3>
          <v-autocomplete
            :items="organizations"
            item-text="displayName"
            return-object
            v-model="from"
            :label="$t('from')"
            :rules="[fieldIsRequired('Organization')]"
            class="required_field"></v-autocomplete>
        </v-flex>
        <v-flex md1></v-flex>
        <v-flex md3>
          <v-autocomplete
            :items="organizations"
            item-text="displayName"
            return-object
            v-model="to"
            :label="$t('to')"
            :rules="[fieldIsRequired('Organization')]"
            class="required_field"></v-autocomplete>
        </v-flex>
      </v-layout>
      <v-layout align-end justify-start>
        <v-flex md3>
          <v-text-field
            :label="$t('upc')"
            class="required_field"
            v-model="upc"></v-text-field>
        </v-flex>
        <v-flex md1></v-flex>
        <v-flex md3>
          <v-text-field
            :label="$t('quantity')"
            class="required_field"
            :rules="[fieldIsNumber(), fieldIsNoLessThanZero()]"
            v-model.number="quantity"></v-text-field>
        </v-flex>
      </v-layout>
      <v-textarea
        id="balance_note"
        :label="$t('note')"
        outline
        v-model="note"></v-textarea>
    </template>
  </FormSubmitPopup>
</template>

<script>
import FormSubmitPopup from './FormSubmitPopup'
import { checkRules } from '@/utils/tools'

export default {
  name: 'AdjustInventory',
  components: {
    FormSubmitPopup
  },
  mixins: [checkRules],
  data () {
    return {
      upc: '',
      quantity: 0,
      note: '',
      from: {},
      to: {},
      warehouseSite: {}
    }
  },
  mounted () {
    this.warehouseSite = this.warehousesSites.find(item => item.key === this.defaultSite)
  },
  computed: {
    organizations () {
      return [...this.$store.getters.sortedWarehouseOrganizations]
    },
    warehousesSites () {
      return this.$store.getters.warehousesSites
    },
    defaultSite () {
      return window.localStorage.getItem('defaultSite' + this.$store.getters.uid)
    }
  },
  methods: {
    onSubmitted () {
      return this.$store.dispatch('adjustInventory', this.$data)
        .then(() => {
          return this.actionAfterSubmit()
        })
    }
  },
  props: {
    value: Boolean,
    actionAfterSubmit: Function
  }
}
</script>



// WEBPACK FOOTER //
// src/components/WarehouseAdjustInventory.vue